import React, { useState, useEffect, useContext, useRef } from "react";
import EmpresaContext from "../../../../../../contexts/Empresa";
import api from "../../../../../../services/api";
import Avatar from "../../../../../../components/Avatar";
import { Progress } from "reactstrap";

// svg
import goldPosition from "../../../../../../assets/img/PlayneeRanking/Ouro.png";
import silverPosition from "../../../../../../assets/img/PlayneeRanking/Prata.png";
import bronzePosition from "../../../../../../assets/img/PlayneeRanking/Bronze.png";
//

import "./style.css";

interface Props {
  colaboradores: Array<any>;
  unidade: any;
  pageProperties: any;

  onTableChange(
    type: string,
    sortProperties: {
      page: number;
      sizePerPage: number;
      sortField: string;
      sortOrder: string;
    }
  ): Promise<void>;
  notify(type: string, msg: string): void;
  loading: boolean;
}

export const Ranking: React.FC<Props> = ({
  colaboradores,
  unidade,
  pageProperties,
  onTableChange,
  notify,
  loading,
  ...props
}) => {
  function convertToMoney(value: number) {
    if (unidade && unidade == "M") {
      return Number(value).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    } else {
      return parseInt(String(value));
    }
  }

  const parseSafe = (val: any): number => {
    if (typeof val === "string") {
      // se contém vírgula (ex: "13.333,33")
      if (val.includes(",")) {
        return Number(val.replace(/\./g, "").replace(",", "."));
      }
      // se já vem em ponto (ex: "13333.33")
      return Number(val);
    }

    // se já é number
    if (typeof val === "number") return val;

    return 0;
  };

  console.log(colaboradores, "colaboradores");

  const Colaborador: React.FC<{ data: any[] }> = ({ data }) => {
    if (data.length === 0) {
      return (
        <div className="rankingLateralNoItem">
          <p>Nenhum item encontrado</p>
        </div>
      );
    } else {
      return (
        <>
          {data.map((item, index) => {
            const vendas = parseSafe(item.vendas_colaborador);
            const meta = parseSafe(item.meta_colaborador);
            const percentual = Math.min(Math.round((vendas / meta) * 100), 100);
            const faltam = vendas >= meta ? 0 : meta - vendas;

            // Adicionando a cor da borda de acordo com o index (ranking)
            let borderColor;
            if (index === 0) {
              borderColor = "#0638CB"; // Dourado (1º lugar)
            } else if (index === 1) {
              borderColor = "#8682B9"; // Prata (2º lugar)
            } else if (index === 2) {
              borderColor = "#E0BC6B"; // Bronze (3º lugar)
            } else {
              borderColor = "#A5826D"; // Cor neutra para outros casos
            }

            return (
              <div className="rankingLateral" key={index}>
                <div className="rankingPosicao">
                  <p className="posicao-number">{index + 1}</p>
                </div>
                <div className="container-ranking">
                  <div className="boxAvatar">
                    <Avatar
                      title={item.user.name}
                      user={item.user}
                      className="avatar"
                      style={{
                        cursor: "default",
                        border: `3px ${borderColor} solid`,
                        width: "80px",
                        height: "80px",
                      }}
                    />
                  </div>
                  <div className="boxInfoRanking">
                    <div className="boxUserName">
                      <p className="nomeColaboradorLateral">{item.user.name}</p>
                    </div>
                    <div className="boxMeta">
                      <div className="boxMeta-venda">
                        <p className="paragraph-empresas">Vendas: </p>
                        <p className="venda">
                          {convertToMoney(item.vendas_colaborador)}
                        </p>
                      </div>
                      <div className="boxMeta-meta">
                        <p className="paragraph-empresas">Meta: </p>
                        <p className="meta">
                          {convertToMoney(item.meta_colaborador)}
                        </p>
                      </div>
                    </div>
                    <div className="container-progress">
                      <Progress
                        value={percentual}
                        color="info"
                        style={{
                          width: "70%",
                          height: "8px",
                          borderRadius: "10px",
                          margin: 0,
                        }}
                      />
                      <span className="percentual-text">{percentual}%</span>
                    </div>
                    <div className="boxMeta-faltam">
                      <p className="paragraph-empresas">Faltam: </p>
                      <p className="faltam">{convertToMoney(faltam)}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      );
    }
  };

  // tentativa de retornar jsx com o card gold completo e posicionado

  interface user {
    avatar: string;
    avatar_url: string;
    cpf_cnpj: any;
    created_at: Date;
    email: string;
    id: number;
    name: string;
    recovery_password_token: any;
    situacao: string;
    status: boolean;
    updated_at: Date;
  }
  interface colaborador {
    impacto: number;
    meta_colaborador: number;
    meta_geral: number;
    name: string;
    user: user;
    user_id: number;
    vendas_colaborador: number;
    vendas_geral: number;
  }

  const Gold: React.FC<{ data: colaborador | null }> = ({ data }) => {
    console.log(data);
    if (data !== null) {
      return (
        <>
          {/* titulo do desafio */}
          {/* <h1 className='tituloRanking'>MAISLASER</h1> */}
          <img className="goldPosition" src={goldPosition} />
          <div className="goldAvatar">
            <Avatar
              title={data.user.name}
              user={data.user}
              className="avatar"
              style={{
                cursor: "default",
              }}
            />
            <div className={`nomePodioContainer nomePodio-gold`}>
              <p className="nomePodio">
                {data.name.split(" ").slice(0, 2).join(" ")}
              </p>
            </div>
          </div>
          {/* premio */}
          {/* <div className='premio'>
            <div className='premioGold' />
            <p>JBL</p>
          </div> */}
        </>
      );
    } else {
      return (
        <>
          <img className="goldPosition" src={goldPosition} />
          <div className="goldElipse">
            <div className="elipse" />
          </div>
        </>
      );
    }
  };

  const Silver: React.FC<{ data: colaborador | null }> = ({ data }) => {
    if (data !== null) {
      return (
        <>
          <img className="silverPosition" src={silverPosition} />
          <div className="silverAvatar">
            <Avatar
              title={data.user.name}
              user={data.user}
              className="avatar"
              style={{
                cursor: "default",
              }}
            />
            <div className={`nomePodioContainer nomePodio-silver`}>
              <p className="nomePodio">
                {data.name.split(" ").slice(0, 2).join(" ")}
              </p>
            </div>
          </div>
          {/* premio */}
          {/* <div className='premio'>
            <div className='premioSilver' />
            <p>Ingressos</p>
          </div> */}
        </>
      );
    } else {
      return (
        <>
          <img className="silverPosition" src={silverPosition} />
          <div className="silverElipse">
            <div className="elipse" />
          </div>
        </>
      );
    }
  };

  const Bronze: React.FC<{ data: colaborador | null }> = ({ data }) => {
    if (data !== null) {
      return (
        <>
          <img className="bronzePosition" src={bronzePosition} />
          <div className="bronzeAvatar">
            <Avatar
              title={
                data.user.name.length > 20
                  ? `${data.user.name.slice(0, 20)}\n${data.user.name.slice(
                      20
                    )}`
                  : data.user.name
              }
              user={data.user}
              className="avatar"
              style={{
                cursor: "default",
              }}
            />
            <div className={`nomePodioContainer nomePodio-bronze`}>
              <p className="nomePodio">
                {data.name.split(" ").slice(0, 2).join(" ")}
              </p>
            </div>
          </div>
          {/* premio */}
          {/* <div className='premio'>
            <div className='premioBronze' />
            <p>Chocolate</p>
          </div> */}
        </>
      );
    } else {
      return (
        <>
          <img className="bronzePosition" src={bronzePosition} />
          <div className="bronzeElipse">
            <div className="elipse" />
          </div>
        </>
      );
    }
  };

  return (
    <div className="ranking">
      <div className="podioColaboradores">
        <div className="silverColaborador">
          <Silver
            data={
              colaboradores
                ? colaboradores[1]
                  ? colaboradores[1]
                  : null
                : null
            }
          />
        </div>
        <div className="goldColaborador">
          <Gold
            data={
              colaboradores
                ? colaboradores[0]
                  ? colaboradores[0]
                  : null
                : null
            }
          />
        </div>
        <div className="bronzeColaborador">
          <Bronze
            data={
              colaboradores
                ? colaboradores[2]
                  ? colaboradores[2]
                  : null
                : null
            }
          />
        </div>
      </div>
      <div className="rankingTen">
        <Colaborador data={colaboradores} />
      </div>
    </div>
  );
};
